
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uprn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"propertyInformationByUPRN"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uprn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uprn"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uprn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"full_address"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"use_class_description_2020"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"property_class_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"property_class_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"coordinates"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"voa_record"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uarn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valuations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ba_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"primary_description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"list_year"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dimensions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"area_floor_total_metric"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"building_height"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uprn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rel_h_max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rel_h_to_roof"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no_floors_estimate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"epc"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"appraisal_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current_energy_rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"potential_energy_rating"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"current_energy_efficiency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"potential_energy_efficiency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"property_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"built_form"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"total_floor_area"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tenure"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"number_habitable_rooms"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"roof_type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"construction_age_band"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":920}};
    doc.loc.source = {"body":"query ($uprn: String!) {\n  propertyInformationByUPRN(uprn: $uprn) {\n    address {\n      uprn\n      full_address\n      use_class_description_2020\n      property_class_description\n      property_class_code\n      state\n\n      location {\n        coordinates\n      }\n\n      voa_record {\n        uarn\n        valuations {\n          ba_name\n          primary_description\n          total_value\n          total_area\n          list_year\n        }\n      }\n    }\n\n    dimensions {\n      area_floor_total_metric\n    }\n\n    building_height {\n      uprn\n      rel_h_max\n      rel_h_to_roof\n      no_floors_estimate\n    }\n\n    epc {\n      appraisal_date\n      current_energy_rating\n      potential_energy_rating\n      current_energy_efficiency\n      potential_energy_efficiency\n      property_type\n      built_form\n      total_floor_area\n      tenure\n      number_habitable_rooms\n      roof_type\n      construction_age_band\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
